import { useController } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { ImportFormat } from '@/modules/api/codegen';
import { RadioButtonGroup, SettingsFormItem } from '@/modules/forms';

import { Fields } from '../../../constants';
import type { ImportFormValues } from '../../../schemas';

// Explicit order — codegen order follows OpenAPI spec, not UI preference.
const options: ImportFormat[] = [
    ImportFormat.passwd,
    ImportFormat.onepassword,
    ImportFormat.dashlane,
    ImportFormat.lastpass,
    ImportFormat.nordpass,
];

const name = Fields.SECRETS_FORMAT;

export const SecretsFormatField = () => {
    const {
        field: { ref, ...field },
    } = useController<ImportFormValues, typeof name>({ name });

    return (
        <SettingsFormItem name={name} label={<FormattedMessage id='import.form.secretsFormat.label' />}>
            <RadioButtonGroup
                {...field}
                optionType='button'
                options={options.map(value => ({
                    label: <FormattedMessage id={`import.form.secretsFormat.${value}`} />,
                    value,
                }))}
                backgroundColor='backgroundsSecondary'
            />
        </SettingsFormItem>
    );
};
